"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OdnoklassnikiIcon;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("../../SvgIcon"));

var _ref = /*#__PURE__*/_react.default.createElement("path", {
  d: "M13.1367 8.6164C12.3341 9.4246 11.2304 9.92533 10.0046 9.92533C8.78321 9.92533 7.6752 9.42021 6.87255 8.6164C6.06989 7.8082 5.5726 6.69693 5.5726 5.46266C5.5726 4.2284 6.07425 3.11713 6.87255 2.30893C7.67084 1.50073 8.77885 1 10.0046 1C11.2261 1 12.3341 1.50512 13.1367 2.30893C13.9394 3.11713 14.4367 4.2284 14.4367 5.46266C14.4367 6.69693 13.935 7.8082 13.1367 8.6164ZM10.0046 3.4246C9.45063 3.4246 8.95334 3.64861 8.58255 4.02196C8.21612 4.39092 7.98928 4.89605 7.98928 5.45388C7.98928 6.01171 8.21176 6.51244 8.58255 6.8858C8.94898 7.25476 9.45063 7.48316 10.0046 7.48316C10.5586 7.48316 11.0559 7.25915 11.4267 6.8858C11.7932 6.51684 12.02 6.01171 12.02 5.45388C12.02 4.89605 11.7975 4.39532 11.4267 4.02196C11.0559 3.66179 10.5586 3.4246 10.0046 3.4246ZM14.6592 9.9429L15.9591 11.7306C16.0245 11.8228 16.0115 11.9414 15.9198 12.0073C14.8293 12.9078 13.5511 13.5051 12.225 13.8214L14.7377 18.6969C14.8031 18.8419 14.7115 19 14.5545 19H11.8717C11.7932 19 11.7146 18.9473 11.6754 18.8682L10.0046 14.8404L8.32081 18.8551C8.29464 18.9341 8.21612 18.9868 8.12451 18.9868H5.44173C5.28469 18.9868 5.19308 18.8155 5.25851 18.6837L7.77117 13.8214C6.44068 13.5051 5.17999 12.9078 4.07635 12.0073C3.99783 11.9414 3.97165 11.8097 4.03709 11.7306L5.33704 9.9429C5.41556 9.83748 5.54642 9.8243 5.63803 9.90337C6.85946 10.9488 8.37316 11.6384 9.99155 11.6384C11.6099 11.6384 13.1106 10.9619 14.3451 9.90337C14.4498 9.81991 14.5937 9.83309 14.6592 9.9429Z"
});

function OdnoklassnikiIcon(props) {
  return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
    viewBox: "0 0 20 20"
  }, props), _ref);
}

OdnoklassnikiIcon.displayName = 'OdnoklassnikiIcon';
OdnoklassnikiIcon.defaultProps = {
  color: '#ee8208'
};